import { Box, GridToolbarQuickFilter } from '@coolblue-development/becky';
import { GridToolbar } from '@mui/x-data-grid';

export const AgentsDashboardToolbar = (): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}>
      <GridToolbar sx={{ marginRight: 'auto', gap: '15px' }} />
      <GridToolbarQuickFilter
        size="small"
        autoFocus
        debounceMs={1000}
        quickFilterParser={(searchInput: string) =>
          searchInput
            .split(',')
            .map(value => value.trim())
            .filter(value => value !== '')
        }
      />
    </Box>
  );
};
